import { EntityChangeType } from "types/generated";

import type { RunCodeChangesDiffLineType } from "./types";

export const CHANGE_PREFIX: Partial<Record<EntityChangeType, string>> = {
  [EntityChangeType.Add]: "+",
  [EntityChangeType.Delete]: "-",
  [EntityChangeType.Change]: "~",
  [EntityChangeType.ReplaceCreateBeforeDestroy]: "~",
  [EntityChangeType.ReplaceDestroyBeforeCreate]: "~",
  [EntityChangeType.CreateAfterForgotten]: "~",
};

export const CHANGE_COLOR: Partial<Record<EntityChangeType, string>> = {
  [EntityChangeType.Add]: "var(--delta-count-added-text-color)",
  [EntityChangeType.Delete]: "var(--delta-count-deleted-text-color)",
  [EntityChangeType.Change]: "var(--delta-count-changed-text-color)",
  [EntityChangeType.ReplaceCreateBeforeDestroy]: "var(--delta-count-changed-text-color)",
  [EntityChangeType.ReplaceDestroyBeforeCreate]: "var(--delta-count-changed-text-color)",
  [EntityChangeType.CreateAfterForgotten]: "var(--delta-count-changed-text-color)",
};

export const DIFF_LINE_PREFIX: Record<RunCodeChangesDiffLineType, string> = {
  added: "+",
  removed: "-",
  unchanged: " ",
};
